module.exports = __webpack_public_path__ + "img/sandtimer.119ad5f4.svg";